// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".psn-" + {"23":"c35948d61968d57899b3","80":"670725c875430bb350fe","189":"758bee302ec9f9d98a04","266":"e4f727bcde2a13ad182d","280":"529df9485870a9c14eea","332":"458ec0ddf4f9152d9cda","535":"d8a28fcc074ac8bd1d18","622":"26e52e9442b6d2c608dd","940":"c2b5c961c7965b302894"}[chunkId] + ".chunk.js";
};